import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";

type OPERATOR_SOUND_TYPE =
    typeof TYPE_NEW_MESSAGE |
    typeof TYPE_NEW_DIALOG |
    typeof TYPE_TARGET_CLIENT |
    typeof TYPE_NEW_CROSS_OPERATOR_MESSAGE |
    typeof TYPE_OPERATOR_STATUS_CHANGE;

const TYPE_NEW_MESSAGE = "newMessage";
const TYPE_NEW_DIALOG = "newDialog";
const TYPE_TARGET_CLIENT = "targetClient";
const TYPE_NEW_CROSS_OPERATOR_MESSAGE = "newCrossOperatorMessage";
const TYPE_OPERATOR_STATUS_CHANGE = "operatorStatusChange";


export class OperatorApplicationSoundPlayer {
    private static instances: OperatorApplicationSoundPlayer[] = [];

    private typeId: OPERATOR_SOUND_TYPE;
    private audio: HTMLAudioElement;
    private isPlay: boolean = false;
    private repeatTimeout: any;
    private playOnce: boolean = false;

    constructor(typeId: OPERATOR_SOUND_TYPE) {
        this.typeId = typeId;
        this.audio = new Audio();
        this.audio.addEventListener("ended", () => {
            if (!this.playOnce) {
                let repeat = this.repeatAfter;
                if (repeat) {
                    clearTimeout(this.repeatTimeout);
                    this.repeatTimeout = setTimeout(() => {
                        if (this.isPlay) {
                            this.play();
                        }
                    }, repeat * 1000);
                }
            }
        });
        OperatorApplicationSoundPlayer.instances.push(this);
    }

    async play(once: boolean = false, notificationSettings?: CometOperatorApplication.MessageOperatorNotificationConfigOpenApiModel) {
        clearTimeout(this.repeatTimeout);
        let sound = notificationSettings?.soundUrl ?? this.soundUrl;
        if (sound && !OperatorAccountStore.isCabinetIframe) {
            this.playOnce = once;
            this.stop();
            try {
                this.audio.currentTime = 0;
            } catch (e) {

            }
            this.isPlay = true;
            this.audio.src = sound;
            try {
                await this.audio.play();
            } catch (e) {

            }
        }
    }

    get isOnRepeat(): boolean {
        return this.isPlay && this.repeatAfter > 0 && !this.playOnce;
    }

    public stop() {
        clearTimeout(this.repeatTimeout);
        this.isPlay = false;
        try {
            this.audio.pause();
        } catch (e) {

        }
    }

    public static stopAll() {
        for (let instance of this.instances) {
            instance.stop();
        }
    }

    get soundUrl(): string {
        let config = OperatorApplicationConfigInstance;
        let result: string;
        if (this.typeId == TYPE_NEW_DIALOG) {
            result = config.newDialogNotificationSound;
        } else if (this.typeId == TYPE_TARGET_CLIENT) {
            result = config.targetClientNotificationSound;
        } else if (this.typeId == TYPE_NEW_MESSAGE) {
            result = config.newMessageNotificationSound;
        } else if (this.typeId == TYPE_NEW_CROSS_OPERATOR_MESSAGE) {
            result = config.newCrossOperatorMessageNotificationSound;
        } else if (this.typeId == TYPE_OPERATOR_STATUS_CHANGE) {
            result = config.operatorStatusChangeNotificationSound;
        }
        if (result) {
            result = config.getFullSoundPath(result);
        }
        return result;
    }

    get repeatAfter(): number {
        let config = OperatorApplicationConfigInstance;

        if (this.typeId == TYPE_NEW_DIALOG) {
            return config.newDialogNotificationRepeat;
        } else if (this.typeId == TYPE_NEW_MESSAGE) {
            return config.newMessageNotificationRepeat;
        } else if (this.typeId == TYPE_NEW_CROSS_OPERATOR_MESSAGE) {
            return config.newCrossOperatorMessageNotificationRepeat;
        }

        return 0;
    }
}


export const OPERATOR_APPLICATION_SOUND_NEW_MESSAGE = new OperatorApplicationSoundPlayer(
    TYPE_NEW_MESSAGE
);

export const OPERATOR_APPLICATION_SOUND_NEW_DIALOG = new OperatorApplicationSoundPlayer(
    TYPE_NEW_DIALOG
);

export const OPERATOR_APPLICATION_SOUND_TARGET_CLIENT = new OperatorApplicationSoundPlayer(
    TYPE_TARGET_CLIENT
);

export const OPERATOR_APPLICATION_NEW_CROSS_OPERATOR_MESSAGE = new OperatorApplicationSoundPlayer(
    TYPE_NEW_CROSS_OPERATOR_MESSAGE
);

export const OPERATOR_APPLICATION_SOUND_OPERATOR_STATUS_CHANGE = new OperatorApplicationSoundPlayer(
    TYPE_OPERATOR_STATUS_CHANGE
);